module.exports = __webpack_public_path__ + "static/thoughts-2c943a7cdd647225c3a77509f1b0f89a.png";